export const AGREEMENT_STORAGE_KEY = `chop_agreement`;

export const CONSENT_CHECKED_KEY = 'consent_checked_key'


export const UPCOMING_CHANGES = {
  title: "Latest Feature Release",
  intro:
    "We’ve shipped a set of powerful upgrades to enhance your experience:",
  items: [
    {
      title: "GPT-5 with Advanced Reasoning",
      description: "Enjoy smarter, more accurate, and context-aware responses with our upgraded model.",
    },
    {
      title: "GPT-5 Mini for Quicker Responses",
      description: "A faster, cost-efficient version of GPT-5 for well-defined tasks and precise queries.",
    },
    {
      title: "Live Response Streaming",
      description:
        "Watch answers appear in real-time as the model thinks.",
    },
    {
      title: "Feedback Collection",
      description: "Share what you liked or didn’t—help us continuously improve.",
    },
    {
      title: "File Attachment Support",
      description:
        "Attach documents directly in chat for richer, contextual analysis.",
    },
    {
      title: "Sensitive Chat Mode",
      description:
        "Have more personal or private conversations. These chats are not used for any validation or model training.",
    }
  ],
};